<p-messages [(value)]="messages" [closable]="false" [enableService]="false" [escape]="false"></p-messages>
<div *ngIf="showLinks()">
    <p-messages severity="info">
        <ng-template pTemplate>
            <div>
                <div class="font-semibold">
                    Als Interessent registrieren
                </div>
                <div>
                    Wenn Sie über einen zukünftigen Netzausbau an Ihrer Adresse informiert werden möchten, können Sie sich hier als Interessent registrieren:
                </div>
                <a href="https://www.swsls.de/produkte/glasfaser/interesse" target="_blank">
                    <button type="button" pButton label="Als Interessent registrieren" class="p-button-info mt-2"></button>
                </a>
            </div>
        </ng-template>
    </p-messages>
</div>
